export default __webpack_public_path__ + "css/paylater-configurator.css";